import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'ringlead_utils/stores/store-tmp-type';

const getOrgId = (state: RootState) => state.auth.user?.organization?.id;

export const getPusherPrivateChannelName = createSelector(getOrgId, orgId => (orgId ? `private-${orgId}` : null));
